module.exports = __webpack_public_path__ + "media/newstyle/images/stars_4-d31c7d640b3860da0b7604e782c4b0ba.svg";